export const fileRenderer = (file: File): string => {
  return window.URL.createObjectURL(file);
};
